"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusOrbitalSurvey = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
class VenusOrbitalSurvey extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VENUS_ORBITAL_SURVEY,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.SPACE],
            cost: 18,
            metadata: {
                cardNumber: 'P88',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Reveal the top 2 cards of the deck. Take any Venus cards to hand for free. Any other card you either buy or discard.', (eb) => eb.empty().startAction.cards(2).asterix());
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        const cardsDrawn = [game.dealer.dealCard(game), game.dealer.dealCard(game)];
        game.log('You drew ${0} and ${1}', (b) => b.card(cardsDrawn[0]).card(cardsDrawn[1]), { reservedFor: player });
        cardsDrawn.forEach((card) => {
            if (card.tags.includes(Tags_1.Tags.VENUS)) {
                player.cardsInHand.push(card);
                game.log('${0} took ${1} into hand for free', (b) => b.player(player).card(card));
            }
            else {
                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                    if (player.canAfford(player.cardCost)) {
                        return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption(`Pay ${player.cardCost} M€ to keep ${card.name}`, 'Confirm', () => {
                            game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, player.cardCost, {
                                title: 'Select how to pay for Venus Orbital Survey action',
                                afterPay: () => {
                                    player.cardsInHand.push(card);
                                    game.log('${0} drew ${1}', (b) => b.player(player).card(card));
                                }
                            }), DeferredAction_1.Priority.COST);
                            return undefined;
                        }), new SelectOption_1.SelectOption(`Discard ${card.name}`, 'Confirm', () => {
                            game.dealer.discard(card);
                            game.log('${0} discarded ${1}', (b) => b.player(player).card(card));
                            return undefined;
                        }));
                    }
                    else {
                        game.dealer.discard(card);
                        game.log('${0} was discarded as ${1} could not afford to buy it', (b) => b.card(card).player(player));
                        return undefined;
                    }
                }));
            }
        });
        return undefined;
    }
}
exports.VenusOrbitalSurvey = VenusOrbitalSurvey;
//# sourceMappingURL=VenusOrbitalSurvey.js.map